// api.js
import Axios from "axios";
import Cookies from "js-cookie";
import { Authentication } from "./Authentication";

const client = Axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
});

const authKey = window.__env.TOKEN_NAME;

client.interceptors.request.use(function (config) {
  if (config.url.includes('login')) return config;

  const token = Cookies.get(authKey);

  if (token) config.headers.Authorization = `Bearer ${token}`;

  return config;
}, function (err) {
  return Promise.reject(err);
});

client.interceptors.response.use(
  (res) => res,
  async function (err) {
    const res = err.response;
    console.log("error response", res.data);
    if (!res.config.url.includes('login') && !res.config.url.includes('change-password')) {
      if (res.status === 401) {
        if (res.data?.message === "token expired") {
          const refreshToken = Cookies.get(window.__env.REF_TOKEN_NAME || "vespa-ref-token");

          if (!refreshToken) {
            Cookies.remove(authKey);
            window.location.href = `/${window.__env.TENANT_PATH}`;
            return Promise.reject(err)
          }

          const { data: creds } = await handleRefreshToken(refreshToken);
          Cookies.set(window.__env.TOKEN_NAME || "vespa-token", creds.token);
          Cookies.set(window.__env.REF_TOKEN_NAME || "vespa-ref-token", creds.refreshToken);
          console.log("new tokens", creds);
          res.config.headers.Authorization = `Bearer ${creds.token}`;
          // window.location.reload();
          return client(res.config);
        }
        else {
          Cookies.remove(authKey);
          window.location.href = `/${window.__env.TENANT_PATH}`;
        }
      }
    }
    return Promise.reject(err);
  });

function handleRefreshToken(refreshToken) {
  return Authentication.token(refreshToken);
}

export default client;